import { ENV_NAME } from 'config/env-config';
import { capitalize } from 'lodash';
import { cn } from 'utils/cn';

function EnviromentBadge() {
  const isProd = ENV_NAME === 'production';
  return (
    <div className="flex max-w-fit items-center gap-2 rounded-lg pl-2 pr-2.5 transition-colors">
      <div className="relative size-2">
        <div className="absolute inset-0 m-auto size-2 animate-ping items-center justify-center rounded-full group-hover:animate-none bg-green-500"></div>
        <div
          className={cn(
            'absolute inset-0 z-10 m-auto size-2 rounded-full',
            isProd ? 'bg-green-400' : 'bg-yellow-400'
          )}
        ></div>
      </div>
      <p className="text-xs font-medium leading-none text-gray-500">
        {capitalize(ENV_NAME)}
      </p>
    </div>
  );
}

export default EnviromentBadge;
